
import Enumerable from "linq";
import { Component, Mixins } from "vue-property-decorator";
import {
  ISize,
} from "../../../../../base/domain/drawing";
import { FileToBase64TextConverter } from "../../../../../base/utilities";
import { DomainRegistry } from "../../../../domain/";

@Component
export default class UploadImageFileMixin extends Mixins() {
  isUploading: boolean = false;
  uploadedImage(imageGuid: string, size: ISize<number>, fileName: string): void {}

  uploadImages(files: FileList): void {
    Enumerable.from(files).forEach((e, i) => this.uploadImage(e));
  }

  private uploadImage(file: File): void {
    FileToBase64TextConverter.convert(file, p => this.upload(p, file.name), () => {
      this.$error(
        "読み込み失敗",
        "ファイルの読み込みに失敗しました。",
      );
    });
  }

  private upload(contents: string, fileName: string): void {
    this.isUploading = true;
    const repository = DomainRegistry.instance.editableFormat.getFormatRepository();
    repository.uploadImageFile(contents)
    .then(async imageGuid => {
      const imageSource = repository.getTemporaryImageSource(imageGuid);
      const size = await this.getNaturalSize(imageSource.source);
      this.uploadedImage(imageGuid, size, fileName);
    })
    .catch(e => {
      this.$error(
        "アップロード失敗",
        "ファイルのアップロードに失敗しました。",
        e,
      );
    })
    .finally(() => {
      this.isUploading = false;
    });
  }

  private async getNaturalSize(src: string): Promise<ISize<number>> {
    return new Promise((resolve: (value: ISize<number>) => void, reject: () => void) => {
      const img = new Image();
      img.onload = e => {
        const element = e.srcElement as HTMLImageElement;
        resolve({
          width: element.naturalWidth,
          height: element.naturalHeight,
        });
      };
      img.onerror = () => reject();
      img.src = src;
    });
  }
}
